import { render, staticRenderFns } from "./serving-contact-user-search-result.vue?vue&type=template&id=d2539718&"
import script from "./serving-contact-user-search-result.vue?vue&type=script&lang=js&"
export * from "./serving-contact-user-search-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports